import { addToRecord, objectWithoutKeys } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { ThreadQueueMarkAsSeenAction } from '../../domains/threadMarkAsGroupSeen/actions.types';
import { ThreadMarkAsSeenFulfilledAction } from '../../domains/threadMarkAsGroupSeenOnServer/actions.types';

import { ThreadToMarkAsSeen, ThreadsToMarkAsSeen } from './types';

const initialState: ThreadsToMarkAsSeen = {};

export type ThreadsToMarkAsSeenAction = ThreadQueueMarkAsSeenAction | ThreadMarkAsSeenFulfilledAction;

type RemoveThreads = (state: ThreadsToMarkAsSeen, threadsToMarkAsSeen: ThreadToMarkAsSeen[]) => ThreadsToMarkAsSeen;
const removeThreads: RemoveThreads = (state, threadsToMarkAsSeen) => {
  const keysToRemove = threadsToMarkAsSeen.map((threadToMarkAsSeen) => threadToMarkAsSeen.threadId);

  return objectWithoutKeys(state, keysToRemove);
};

const reducer: Reducer<ThreadsToMarkAsSeen, ThreadsToMarkAsSeenAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'THREAD.QUEUE_MARK_AS_GROUP_SEEN':
      return addToRecord(state, action.payload.threadToMarkAsSeen.threadId, action.payload.threadToMarkAsSeen);
    case 'THREAD.MARK_AS_GROUP_SEEN_FULFILLED':
      return removeThreads(state, action.payload.threadsToMarkAsSeen);
    default:
      return state;
  }
};

export default reducer;
